module.exports = __webpack_public_path__ + "static/media/creative-tim-white-slim2.f7cb2d39.png";